import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';
import './ProjectSearchBar.css';

const SearchFilter = ({ handleChange }) => {
  const handleSubmit = e => e.preventDefault();
  const searchBar = (
    <div id="project-search-bar" onSubmit={handleSubmit}>
      <Image id="search-image" src="/icon/Union.png" />
      <input
        className="project-search-input-file"
        type="text"
        onChange={handleChange}
      />
    </div>
  );
  return <div>{searchBar}</div>;
};

SearchFilter.propTypes = {
  handleChange: PropTypes.func.isRequired,
};

export default SearchFilter;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSearchBar.js